import { createPrefixer } from '.'

const ROOT = 'ver-cuentas-x-pagar' as const
export const RESOURCE_CXP = 'CxP' as const
const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pt = createPrefixer(ROOT, 'transacciones')
const pc = createPrefixer(ROOT, 'configuracion')
const pi = createPrefixer(ROOT, 'informes')

const permission = {
    _root: ROOT,
    _resource: RESOURCE_CXP,
    dashboard: {
        _perm: rp('dashboard'),
    },
    transacciones: {
        _perm: rp('transacciones'),
        reembolsos: {
            _perm: pt('reembolsos'),
            bandejaReembolsoInterno: pt('bandeja-reembolso-interno'),
            reembolsoInterno: pt('reembolso-interno'),
            aprobacionReembolsoInterno: pt('aprobacion-reembolso-interno'),
        },
        ordenesPago: {
            _perm: pt('ordenes-pago'),
            bandejaOrdenPago: pt('bandeja-orden-pago'),
            ordenPagoSinFlujo: pt('orden-pago'),
        },
        registroDocumentos: {
            _perm: pt('registro-documentos'),
            bandejaRegistroDocumento: pt('bandeja-registro-documento'),
            registroDocumento: pt('registro-documento'),
            aprobacionRegistroDocumento: pt('aprobacion-registro-documento'),
            asignacionOrdenEntrega: pt('asignacion-ordenes-entrega'),
            asignacionTareas: pt('asignacion-tareas'),
            aprobacionCruceRegdoc: pt('aprobacion-cruce-regdoc'),
            importacionesPendientes: pt('bandeja-importaciones-pendientes'),
        },
        anticipos: {
            _perm: pt('anticipos'),
            bandejaAnticipos: pt('bandeja-anticipos'),
            crearAnticipo: pt('crear-anticipo'),
            aprobacionAnticipos: pt('aprobacion-anticipos'),
        },
        notasCredito: {
            _perm: pt('notas-credito'),
            bandejaNotaCredito: pt('bandeja-nota-credito'),
            notaCredito: pt('nota-credito'),
        },
        abonos: {
            _perm: pt('abonos'),
            bandejaAbonos: pt('bandeja-abonos'),
            crearAbono: pt('crear-abono'),
        },
        notaDebito: pt('nota-debito'),
        liquidacionEmbarques: pt('liquidacion-embarques'),
        liquidacionCompraServicio: pt('liquidacion-compra-servicio'),
    },
    configuracion: {
        _perm: rp('configuracion'),
        nivelAprobacionAnticipos: pc('nivel-aprobacion-anticipos'),
        asignacionTareas: pc('asignacion-tareas'),
        fechaLimiteRegdoc: pc('fecha-limite-regdoc'),
        correoAlertasPendientes: pc('correo-alertas-pendientes'),
        usuariosNotificacion: pc('alerta-gasto-importacion'),
    },
    informes: {
        _perm: rp('informes'),
        saldoAnticipos: pi('saldos-anticipos'),
        proveedoresCorte: pi('proveedores-corte'),
        obligacionesVencerVencidas: pi('obligaciones-vencer-vencidas'),
        cartera306090: pi('cartera-30-60-90'),
        estadoCuenta: pi('estado-cuenta'),
        flujoPagoProveedor: pi('flujo-pago-proveedor'),
    },
}

export default permission
